import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import DeleteIcon from "@mui/icons-material/Delete"
import { Stack, Collapse } from "@mui/material"
import { ReactElement } from "react"

import { GRID_SPACING } from "../../../../../themes/defaultThemeParams"
import AppButton from "../../../../buttons/appButton"

interface IArrayFormHelperButtonsProps {
    onClickDuplicate: () => void
    onClickRemove: () => void
    showRemoveButton: boolean
}

/**
 * Renders buttons to help manage forms controlled by the useFieldArray hook
 * from react hook form.
 */
const ArrayFormHelperButtons = ({
    onClickDuplicate,
    onClickRemove,
    showRemoveButton,
}: IArrayFormHelperButtonsProps): ReactElement => (
    <Stack direction="row" spacing={GRID_SPACING}>
        <AppButton
            onClick={onClickDuplicate}
            variant="outlined"
            endIcon={<ContentCopyIcon />}
        >
            Duplicate
        </AppButton>
        <Collapse in={showRemoveButton} orientation="horizontal">
            <AppButton
                onClick={onClickRemove}
                variant="outlined"
                endIcon={<DeleteIcon />}
                disabled={!showRemoveButton}
            >
                Remove
            </AppButton>
        </Collapse>
    </Stack>
)

export default ArrayFormHelperButtons
